import { useEffect } from "react";

import { IoArrowUpOutline } from "../Icon/io5/IoArrowUpOutline";

export default function GoToTop() {
  useEffect(() => {
    const calcScrollValue = () => {
      const scrollProgress = document.getElementById("progress");
      const pos = document.documentElement.scrollTop;

      if (pos > 2000) {
        scrollProgress.style.opacity = 1;
        scrollProgress.style.pointerEvents = "auto";
      } else {
        scrollProgress.style.opacity = 0;
        scrollProgress.style.pointerEvents = "none";
      }
      scrollProgress.addEventListener("click", (event) => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        event.preventDefault();
      });
    };

    window.addEventListener("scroll", calcScrollValue, { passive: true });
    window.addEventListener("load", calcScrollValue, { passive: true });

    return () => {
      window.removeEventListener("scroll", calcScrollValue);
      window.removeEventListener("load", calcScrollValue);
    };
  });

  return (
    <div id="progress" className="fixed !z-[9999999999]">
      <span id="progress-value">
        <IoArrowUpOutline size={30} />
      </span>
    </div>
  );
}
